import familiadosApiClient from '$utils/familiadosApiClient'
import {
  CaretakerRecommendationDto,
  RecommendationService,
  RecommendationServiceOutSession,
  RecruitingService,
  BroadcastService,
  ResidenceRecommendationService,
} from './recommendation.model'
import {
  basicDataResponseToModel,
  mapBroadcastServiceToDtoModel,
  mapResidenceRecommendationServiceToDtoModel,
} from './recommendation.mapper'
import { apiErrorService } from '$utils/services/apiErrorService'
import { CaretakerReview } from './recommendation.model'
import {
  newRecommendationServicePath,
  newRecommendationServiceOutSessionPath,
  newRecruitingServicePath,
  confirmRecruiterRequestPath,
  newRecommendationServiceSelectedCaretakerPath,
  newRecommendationServiceSelectedCaretakerOutSessionPath,
} from '$infrastructure/routes'
import { userGroupService } from '$utils/services/userGroupService'
import { apiRouter } from '$domain/model/apiRouter'

export const getRecommendationBasicData = async (serviceId: string, token: string) => {
  try {
    const recommendationBasicData = await familiadosApiClient.get<CaretakerRecommendationDto>(
      apiRouter.getRecommendationBasicDataPath(serviceId),
      { token },
    )
    return basicDataResponseToModel(recommendationBasicData)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const getRecommendationReviews = (caretakerId: string) => {
  try {
    return familiadosApiClient.get<CaretakerReview[]>(apiRouter.getRecommendationReviewsPath(caretakerId))
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const newRecommendationService = async (service: RecommendationService) => {
  try {
    return await familiadosApiClient.post(newRecommendationServicePath, service)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

const addGuestToUserGroup = user => {
  if (user.guest || user.isGuest) {
    userGroupService.saveUserGroup('Invitado')
  }
}

export const newRecommendationServiceOutSession = async (service: RecommendationServiceOutSession) => {
  try {
    const resposeRecomendacionServiceOutSession = await familiadosApiClient.post<{
      guest: boolean
    }>(newRecommendationServiceOutSessionPath, service)
    addGuestToUserGroup(resposeRecomendacionServiceOutSession)

    return resposeRecomendacionServiceOutSession
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const newRecommendationServiceSelectedCaretaker = async (service: RecommendationService, caretakerId) => {
  try {
    return await familiadosApiClient.post(newRecommendationServiceSelectedCaretakerPath(caretakerId), service)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const newRecommendationServiceSelectedCaretakerOutSession = async (
  service: RecommendationServiceOutSession,
  caretakerId,
) => {
  try {
    const resposeRecomendacionServiceOutSession = await familiadosApiClient.post<{
      guest: boolean
    }>(newRecommendationServiceSelectedCaretakerOutSessionPath(caretakerId), service)
    addGuestToUserGroup(resposeRecomendacionServiceOutSession)

    return resposeRecomendacionServiceOutSession
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const newRecruitingService = async (service: RecruitingService) => {
  try {
    await familiadosApiClient.post(newRecruitingServicePath, service)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const confirmRecruiterRequest = async (requestId: string) => {
  try {
    await familiadosApiClient.post(confirmRecruiterRequestPath(requestId))
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const newBroadcastService = async (service: BroadcastService) => {
  try {
    const serviceDto = mapBroadcastServiceToDtoModel(service)
    const broadcastServiceResponse = await familiadosApiClient.post(apiRouter.getNewBroadcastServicePath(), serviceDto)
    addGuestToUserGroup(broadcastServiceResponse)

    return broadcastServiceResponse
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const createResidenceRecommendationService = async (service: ResidenceRecommendationService) => {
  try {
    const serviceDto = mapResidenceRecommendationServiceToDtoModel(service)
    await familiadosApiClient.post(apiRouter.getResidenceRecommendationServicePath(), serviceDto)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/recommendation/recommendation.manager.ts